import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Box, Chip, CircularProgress, Grid, Paper, TextField, MenuItem, Typography, IconButton, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import MyTable from '../../components/Schedule/MyTable';
import MyShiftsTableHeader from '../../components/MyShifts/MyShiftsTableHeader';
import { useSelector, useDispatch } from 'react-redux'
import { setMyBalance, setMyShifts, setMyShiftsDate } from '../../store/myShiftsReducer'
import { setDashboardShifts, setDashboardAbsentReason } from '../../store/dashboardReducer'
import ApiService from '../../functions/apiService';
import { useSnackbar } from 'notistack';
import AuthContext from '../../context/AuthContext';
import { useForm } from 'react-hook-form';
import ManagementHeaderNav from '../../components/HeadersNav/ManagementHeaderNav';
import { formateDate, formateDate2 } from '../../utils/helperFunctions';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MyBalanceTable from '../../components/MyShifts/MyBalanceTable';
import DeleteConfirmation from '../../components/DeleteModal/DeleteModal';
// import EmptyState from '../../components/Error/EmptyState';
import PreAccept from '../../components/MyShifts/PreAccept';
import Modal from 'react-bootstrap/Modal';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import { Col, Row } from 'react-bootstrap';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { SwapVacationModal, SwapModal } from './SwapModal';
import { varFormatTime } from '../../utils/helperFunctions';
import { toast } from 'react-toastify';
import VolunteerPositions from './VolunteerPositions';
import VolunteerShifts from './VolunteerShifts';

export default function MyShifts() {
  let navigate = useNavigate();
  const { user, pages } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [value, setValues] = useState(0);
  const data = useSelector((state) => state.myShiftsReducer.Data)
  const date = useSelector((state) => state.myShiftsReducer.Date)
  const MyBalance = useSelector((state) => state.myShiftsReducer.MyBalance)
  const shifts = useSelector((state) => state.dashboardReducer.Shifts)
  const abscentReasons = useSelector((state) => state.dashboardReducer.AbsentReason)
  const [searchParams, setSearchParams] = useSearchParams();
  const routeDate = searchParams.get('date');
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteBody, setDeleteBody] = useState({});
  const [saving, setSaving] = useState(false);
  const [otherUsers, setOtherUsers] = useState([])
  const [allowedShifts, setAllowedShifts] = useState([])
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleClose1 = () => setOpen(false);
  const [allData, setAllData] = useState([]);
  const [selectedComment, setSelectedComment] = useState('');
  const [selectedRow, setSelectedRow] = useState([]);
  const [userList, setUserList] = useState([])
  const [vacationData, setVacationData] = useState([])
  const [open2, setOpen2] = useState(false)
  const [open3, setOpen3] = useState(false)
  const [cancelData, setCancelData] = useState([])
  const [open4, setOpen4] = useState(false)
  const [shiftData, setShiftData] = useState([])
  const { enqueueSnackbar } = useSnackbar();
	const timeFormat = (timeStr) => timeStr?.slice(0, 5);

  const handleShow = (comment) => {
    setShow(true);
    setSelectedComment(comment);
  }

  const { register, formState: { errors, isDirty, isValid }, handleSubmit, setError, setValue, getValues, watch, } = useForm({
    defaultValues: {
      ShiftCode: '',
      SelAbsent: '',
      SelEmp: ''
    }
  });
  const dispatch = useDispatch()

  const columns = useMemo(() => {
    const baseColumns = [
      ...(value == 6) ? [
        {
          field: 'fullName',
          headerName: 'Name',
          flex: 1,
          minWidth: 140,
          renderCell: (params) => (
          	<p style={{ width: '200px' }}>{params?.row?.orig_emp?.employee_assignment?.EA_Rank + ' ' + params?.row?.orig_emp?.fullName}</p>
          ),
        },
      ] : [],
      {
        field: 'Date',
        headerName: 'Date',
        flex: 1,
				minWidth: 180,
        renderCell: (params) => (
          <p style={{ width: '160px', marginTop: '14px' , marginRight:'10px' }}>{formateDate2(params?.row?.Date ? params?.row?.Date : params?.row?.Shift_Date)}</p>
        ),
      },
      {
        field: 'Shift_Code',
        headerName: 'Shift',
        flex: 1,
        minWidth: 160,
				renderCell: (params) => {
					return <Chip
						sx={{
							height: 'auto',
							'& .MuiChip-label': {
								display: 'block',
								whiteSpace: 'normal',
							},
						}}
						style={{
							textAlign: 'center',
							padding: '6px 0px',
							width: '90%',
							color: '#2E3238',
							fontSize:'12px',
							backgroundColor: params.row.ShiftCode === "2" || params.row.Shift_Code == 2 ? 'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
							border: params.row.ShiftCode === "2" || params.row.Shift_Code == 2 ? '1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)'
						}}
						label={params?.row?.ShiftName ? varFormatTime(params?.row?.ShiftName?.toUpperCase() , user?.Time_Format)  : params?.row?.Shift_Code == 2 ? 'Day' : 'Night'}
					/>;
				},
      },
      ...(value < 1
        ? [
          {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            minWidth: 150,
            valueGetter: (params) => params.row?.Overtime?.OvertimeEmployee,
            renderCell: (params) => (
              <div
                style={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  width: '100%',
                }}
              >
                {params.value}
              </div>
            ),
          },
        ]
        : []),
      {
        field: 'PositionName',
        headerName: 'Position',
        flex: 1,
        minWidth: 160,
        renderCell: (params) => (
					<Chip
						sx={{
							height: 'auto',
							'& .MuiChip-label': {
								display: 'block',
								whiteSpace: 'normal',
							},
						}}
						style={{
							textAlign: 'center',
							padding: '6px 0px',
							width: '100%',
							color: '#2E3238',
							fontSize:'12px',
						}}
						label={params.value ? params.value : params?.row?.orig_emp?.employee_assignment?.Position_Code}
					/>
        ),
      },
      {
        field: 'AssignmentName',
        headerName: 'Assignment',
        flex: 1,
        minWidth: 140,
        renderCell: (params) => (
					<Chip
						sx={{
							height: 'auto',
							'& .MuiChip-label': {
								display: 'block',
								whiteSpace: 'normal',
							},
						}}
						style={{
							textAlign: 'center',
							padding: '6px 0px',
							width: '100%',
							color: '#2E3238',
							fontSize:'12px',
							backgroundColor:'#ddd'
						}}
						label={params.value ? params.value : params?.row?.orig_emp?.employee_assignment?.Assignment_Code}
					/>
        ),
      },
      ...(value < 1
        ? [
          {
            field: 'Description',
            headerName: 'Description',
            flex: 1,
            minWidth: 120,
          },
        ]
        : []),
      ...(value !== 6) ? [
        {
          field: 'Reason',
          headerName: 'Reason',
          flex: 1,
          minWidth: 180,
          filterable: false,
          renderCell: (params) => {
            if (params.row.PTOStatus === 'Q') {
              return (
                <>
                  <span style={{ textOverflow: 'ellipsis', wordBreak: 'break-word' }}>
                    {params.row?.PTOAbsentCode}{' '}
                  </span>
                  <button
                    onClick={() => DeletePTO(params.row?.Date, params.row?.PTOShiftNumber)}
                    className="btn"
                  >
                    <DeleteIcon />
                  </button>
                </>
              );
            }
            else if (params.row.PTOStatus !== 'Q' && params.row.PTOStatus !== '' && pages.includes("V3_DELETE_VACATION_REQUESTS")) {
              return (
                <>
                  <span style={{ textOverflow: 'ellipsis', wordBreak: 'break-word', marginRight: '10px' }}>
                    {params.row?.PTOAbsentCode}{' '}
                  </span>
                  {!params?.row?.isRTORemoveRequest === true &&
                    <Button
                      className="rounded-5"
                      style={{ color: 'rgba(230, 39, 25, 1)', border: '1px solid rgba(230, 39, 25, 0.5)', backgroundColor: 'rgba(230, 39, 25, 0.08)' , fontSize:'13px' }}
                      onClick={() => {
                        setOpen3(true)
                        setCancelData(params?.row)
                      }}
                    >
                    <DeleteIcon style={{height:'18px' , width:'18px'}}/>
                      Remove RTO
                    </Button>
                  }
                </>
              );
            }
            else {
              return <span>{params.row?.PTOAbsentCode}</span>;
            }
          },
        },
      ] : [],
      ...(value !== 6) ? [
        {
          field: 'PTOStatus',
          headerName: 'Status',
          flex: 1,
          minWidth: 110,
          renderCell: (params) => (
            <div
              style={{
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                width: '100%',
              }}
            >
              {params.row.PTOStatus &&
                <Chip
                  style={{
                    textAlign: 'center',
                    backgroundColor:
                      params.row.PTOStatus == 'Q' ? 'orange' :
                        params.row.PTOStatus === 'D' ? '#000000' :
                          params.row.PTOStatus === 'O' ? '#ff0000' :
                            params.row.PTOStatus === 'F' ? '#01784F' : '#000000',
                    cursor: 'pointer',
                    color: '#fff'
                  }}
                  label={params.row.PTOStatus === 'Q' ? 'Requested' :
                    params.row.PTOStatus === 'D' ? 'Do not fill' :
                      params.row.PTOStatus === 'O' ? 'Open Position' :
                        params.row.PTOStatus === 'F' ? 'Filled' : params.row.PTOStatus}
                />
              }
            </div>
          ),
        }
      ] : [],
      ...(value !== 6) ? [
        {
          field: 'Comment',
          headerName: 'Comment',
          flex: 1,
          minWidth: 90,
          renderCell: (params) => (
            params.value ? (
              <div onClick={() => handleShow(params.value)} style={{ cursor: 'pointer' }}>
                <img src='/images/comment.svg' height='20px' width='20px' />
              </div>
            ) : null
          ),
        }
      ] : [],
			{
				field: 'Action',
				headerName: 'Action',
				flex: 1,
				minWidth: 120,
				renderCell: (params) => (
				<>
					{params?.row?.Overtime && pages.includes('V3_OT_SWAPS_FEATURE') &&
						<ButtonTheme disable={saving} color='primary' className="px-3" style={{ fontSize: '13px' }}
							onClick={() => {
								setSelectedRow(params.row);
								setOpen(true);
							}}
						>
							OT Swap
						</ButtonTheme>
					}

					{params?.row?.Overtime && pages.includes("V3_SHIFT_BACK_FEATURE") &&
						<ButtonTheme
							className="rounded-2"
							color='primary'
							style={{ fontSize: '13px' }}
							onClick={() => {
								setOpen4(true)
								setShiftData(params?.row)
							}}
						>
							Give Shift Back
						</ButtonTheme>
					}

					{value == 6 &&
						<div>
							{params?.row?.is_requested_by_me == false ?
								(
									<ButtonTheme disable={saving} color='primary' className="px-2" style={{ fontSize: '13px' }}
										onClick={() => {
											setSelectedRow(params.row);
											setOpen2(true);
										}}
									>
										Request Swap
									</ButtonTheme>
								) :
								(
									<Button disabled className="rounded-5 px-3" style={{ backgroundColor: '#000000', color: '#ffffff', fontSize: '13px' }}>
										Requested
									</Button>
								)
							}
						</div>
					}
				</>
			),
		}
    ];

    return baseColumns;
  }, [value]);

  const loadData = (dateInput = '') => {
    setLoading(true)
    let Query = dateInput != '' ? '?month=' + (dateInput.getMonth() + 1) + '&year=' + dateInput.getFullYear() : ''
    ApiService.get('/myShifts' + Query, {}, 'myShifts').then(({ data }) => {
      dispatch(setMyShifts(data.MySchedule));
      if (data.MyBalance) {
        dispatch(setMyBalance(Object.values(data.MyBalance)));
      }
      setLoading(false)
    }).catch(() => {
      setLoading(false)
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })
  }

  const loadDropDowns = () => {
    ApiService.get('/shiftTypes').then(({ data }) => {
      dispatch(setDashboardShifts(data.data));

    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })
    // params ?condition=all removed as per 9 sept due to inconsistency in data with v1
    ApiService.get('/absentCodes').then(({ data }) => {
      dispatch(setDashboardAbsentReason(data.data));
    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })
    ApiService.get('/employeeToSwap').then(({ data }) => {
      const filteredData = data.filter(u => u.Emp_Code !== user.Emp_Code)
      setOtherUsers(filteredData)
    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })
  }

  const DeletePTO = (date, number) => {
    setOpenModalDelete(true);
    setDeleteBody({
      ShiftDate: date, ShiftNumber: number
    });
  }

  const closeDeletePTO = () => {
    setOpenModalDelete(false);
    setDeleteBody({});
  }

  const deleteItem = () => {
    ApiService.post('/cancelPTO', deleteBody)
      .then((data) => {
        loadData()
        toast.success(data?.message)
        // enqueueSnackbar('success', { variant: 'success' });
        closeDeletePTO()
      })
  }

  useEffect(() => {
    if (routeDate) {
      loadData(new Date(routeDate))
    } else {
      loadData()
    }
    loadDropDowns()
  }, [])

  useEffect(() => {
    if (user.employee_assignment.Group_Code.includes("DAY")) {
      setAllowedShifts(shifts.filter((i) => i.ShiftCode == 2))
    } else {
      setAllowedShifts(shifts)
    }
  }, [shifts])

  const res = useMemo(() => {
    if (data) {
      return data.filter(x => {
        if (value == 0) {
          return x;
        }
        else if (value == 1) {
          return x.IsMainShift == true && x.ShiftClass != "PTO";
        }
        else if (value == 2) {
          return typeof x.Overtime != 'undefined' &&  x.Overtime.DetailType == null ;
        }
        else if (value == 3) {
          return typeof x.Overtime != 'undefined' && x.Overtime.DetailType !== null	;
        }
        // else if (value == 4) {
        //   return navigate('/firehouse/PreAccept')
        // }
        else {
          return x;
        }
      })
    } else {
      return [];
    }
  }, [data, value])

  useEffect(() => {
    res.map((data) => {
      setAllData(data)
    })
  }, [res]);

  const loadOTSwaps = () => {
    setLoading(true);
    ApiService.post("/ot-swap-user-list")
      .then(({ data }) => {
        setUserList(data)
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleLoadOT = () => {
    loadOTSwaps();
  }

  const deleteOtData = (row) => {
    setSaving(true);
    ApiService.post("/ot-swap-delete", {
      "Shift_Value": row?.Value
    })
      .then((data) => {
        setSaving(false);
        toast.success(data?.data)
        // enqueueSnackbar("success", { variant: "success" });
        loadOTSwaps();
      })
      .catch(({ data }) => {
        setSaving(false);
        toast.error(data?.message)
        // enqueueSnackbar("Error", { variant: "error" });
      });
  };

  const loadVacationSwaps = () => {
    setLoading(true);
    ApiService.post("/ot-open-vac-list")
      .then(({ data }) => {
        const updatedData = data.map((item, index) => ({
          ...item,
          id: index + 1
        }))
        setLoading(false);
        setVacationData(updatedData);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
		loadVacationSwaps()
  }, [value == 6])

  const CancelLeaveRequest = (data) => {
    ApiService.post("/request-rto-removal", {
      "Shift_Date": data?.Date,
      "Shift_Number": data?.PTOShiftNumber
    })
      .then((data) => {
        setOpen3(false);
        loadData();
        toast.success(data?.message)
        // enqueueSnackbar("success", { variant: "success" });
      })
      .catch((error) => {
        setOpen3(false);
        if (error && error.status === 400) {
          toast.error(error?.data?.message || "Bad Request")
          // enqueueSnackbar(error?.data?.message || "Bad Request", { variant: "error" });
        } else {
          toast.error("Something went wrong")
          // enqueueSnackbar("Something went wrong", { variant: "error" });
        }
      });
  };

  const ShiftBack = (data) => {
    ApiService.post("/removeAcceptedShift", {
      "Shift_Number": data?.Overtime?.ShiftNumber,
      "Shift_Date": data?.Overtime?.Shift_Date,
    })
      .then((data) => {
        setOpen4(false);
        loadData()
        toast.success(data?.message)
        // enqueueSnackbar("success", { variant: "success" });
      })
      .catch((error) => {
        setOpen4(false);
        if (error && error.status === 400) {
          toast.error(error?.data?.message || "Bad Request")
          // enqueueSnackbar(error?.data?.message || "Bad Request", { variant: "error" });
        } else {
          toast.error("Something went wrong")
          // enqueueSnackbar("Something went wrong", { variant: "error" });
        }
      });
  };


  return (
    <>
      <ManagementHeaderNav />
      <Paper className='p-3' style={{ marginTop: "1rem" }}>
        <div className='my-shifts'>
          <Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
            <Grid item xs={12}>
              <Typography variant="h6">My Shifts</Typography>
              <div className='my-3'>
                <div className='d-flex justify-content-between flex-wrap '>
                  <div className='small-navigator'>
                    <MyShiftsTableHeader value={value} setValue={setValues} handleLoadOT={handleLoadOT} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className='py-0'>
          {loading && <Box className="w-100 d-flex justify-content-center align-items-center"
            style={{ height: '505px' }}>
            <CircularProgress />
          </Box>
          }
          {!loading && res.length > 0 && value != 4 && value != 5 && value != 6 && value != 7 &&
            <Box sx={{ maxWidth: '93vw', overflowX: 'auto', background: '#FFF' }}>
              <MyTable rows={res} columns={columns} useTopFilter={false} checkboxSelection={false} hideFooter={true} />
            </Box>
          }
          {value == 4 && <PreAccept setLoading={setLoading} />}
          {!loading && value == 6 &&
            <MyTable rows={vacationData} columns={columns} useTopFilter={false} checkboxSelection={false} hideFooter={true} />
          }
          {/* {MyBalance && MyBalance.length > 0 &&
                <MyBalanceTable MyBalance={MyBalance} />
          } */}
					{value==7 && <VolunteerPositions/>}
					{/* {value==8 && <VolunteerShifts/>} */}
          {!loading && (res.length == 0) && (value == 0 || value == 1 || value == 2 || value == 3 || value == 4) &&
            <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 505 }}>
              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
              <span className='mt-4' style={{ color: '#555555' }}>
                No Shifts Found
              </span>
            </div>
          }

          {!loading && (value == 5) && (userList.length == 0) &&
            <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 505 }}>
              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
              <span className='mt-4' style={{ color: '#555555' }}>
                No Shifts Found
              </span>
            </div>
          }
        </div>
        <div>
          {!loading && (value == 5) && (
            <Box
              sx={{
                maxWidth: "93vw",
                overflowX: "auto",
                background: "#FFF",
              }}
            >
              <Grid container spacing={2} className='mt-1'>
                {userList.length > 0 && (
                  userList.map((obj) => {
                    {
                      return (
                        <Grid item xs={4}>
                          <Box
                            sx={{
                              padding: '16px',
                              backgroundColor: '#ffffff',
                              borderRadius: '12px',
                              border: '1px solid #EBECF0',
                              boxShadow: `
                              0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
                              0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
                              0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
                            `,
                            }}
                          >
                            <TableContainer>
                              <Table aria-label="simple table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell align="left" style={{ padding: '0px', paddingBottom: '16px', fontSize: '16px', fontWeight: 550, fontFamily: 'karla' }}>
                                      Shift
                                    </TableCell>
                                    <TableCell align="right" style={{ fontSize: '16px', fontWeight: 550, fontFamily: 'karla', padding: '0px', paddingBottom: '16px', }}>
                                      {obj?.swap_by_shift_details?.Shift_Code == '2' ? 'Day' : 'Night'}
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  <TableRow key={obj.Value} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell
                                      component="th"
                                      scope="row"
                                      style={{
                                        padding: '0px',
                                        fontSize: '14px',
                                        fontFamily: 'karla',
                                        padding: '7px',
                                        color: '#555555',
                                      }}
                                    >
                                      <p style={{ marginBottom: '3px' }}>
                                        <span style={{ fontWeight: '600' }}>Requested by :</span>
                                        <span style={{ color: '#000000', marginLeft: '3px' }}>
                                          {obj?.swap_request_by?.fullName}
                                        </span>
                                        , Shift -
                                        <span style={{ color: '#000000', fontWeight: '400 !important' }}>
                                          {obj?.swap_by_shift_details?.Shift_Date}
                                        </span>
                                      </p>

                                      <p style={{ marginBottom: obj?.Status == 'ACTIVE' ? '10px' : '16px' }}>
                                        <span style={{ fontWeight: '600' }}>
                                          Requested to :
                                        </span>
                                        <span style={{ color: '#000000' }}> {obj?.swap_with?.fullName}</span>
                                        , Shift - <span style={{ color: '#000000' }}> {obj?.swap_to_shift_details?.Shift_Date}</span>
                                      </p>


                                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Chip
                                          style={{ textAlign: 'center', backgroundColor: obj?.Status == 'DENIED' ? '#ff0000' : '#01784F', cursor: 'pointer', color: '#fff' }}
                                          label={obj.Status}
                                        />
                                        {obj?.Status == 'ACTIVE' &&
                                          <div>
                                            <ButtonTheme
                                              disable={saving}
                                              color="red"
                                              className="rounded-2"
                                              onClick={() => deleteOtData(obj)}
                                            >
                                              Delete
                                            </ButtonTheme>
                                          </div>
                                        }
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                        </Grid>
                      );
                    }
                  })
                )}
              </Grid>
            </Box>
          )}
        </div>
      </Paper>
      <DeleteConfirmation openModal={openModalDelete} acceptFunction={deleteItem} rejectFunction={closeDeletePTO} />
      
			<Modal show={open} size='lg' onHide={handleClose1}>
				<Modal.Header style={{marginRight:'8px'}} closeButton>
					<Modal.Title style={{paddingLeft:'15px'}}><Typography fontWeight={700} fontSize={21}>List of Overtime Members</Typography></Modal.Title>
				</Modal.Header>
        <Modal.Body className='p-0'>
          <SwapModal
            loadData={loadData}
            setOpen={setOpen}
            res={res}
            selectedRow={selectedRow}
            backFunction={() => {
              setOpen(false)
            }}
          />
        </Modal.Body>
      </Modal>

      <Modal show={open2} size='md'>
        <Modal.Body className='p-0'>
          <SwapVacationModal
            loadData={loadVacationSwaps}
            setOpen={setOpen2}
            selectedRow={selectedRow}
            backFunction={() => {
              setOpen2(false)
            }}
          />
        </Modal.Body>
      </Modal>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Comment</Modal.Title>
        </Modal.Header>
        <Modal.Body className='pb-4'>{selectedComment || 'No any Comments'}</Modal.Body>
      </Modal>

      <Modal show={open3} onHide={() => setOpen3(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ color: '#555555' }}>
            Are you sure to send a request to cancel your leave ?
          </div>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setOpen3(false)}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => CancelLeaveRequest(cancelData)}>
                Yes
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal show={open4} onHide={() => setOpen4(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Shift Removal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ color: '#555555' }}>
            Are you sure to give back your Shift ?
          </div>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setOpen4(false)}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => ShiftBack(shiftData)}>
                Yes
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}
